export type EtatRecherche = 'a_faire' | 'en_cours' | 'fait' | 'sans_objet';
export interface EtapeRecherche {
  code: string;
  libelle: string;
  etat: EtatRecherche;
  motif: string | null;
}

const DERNIERE = 'REC-08';

const terminee = (e: EtapeRecherche): boolean => e.etat === 'fait' || (e.etat === 'sans_objet' && (e.motif ?? '').trim() !== '');

/** La prescription acquisitive (REC-08, #42) vient toujours en dernier : REC-01 à REC-07 faites, ou sans objet motivé. */
export function peutActiver(etapes: readonly EtapeRecherche[], code: string): { ok: boolean; raison?: string } {
  if (code !== DERNIERE) return { ok: true };
  if (etapes.filter((e) => e.code !== DERNIERE).every(terminee)) return { ok: true };
  return { ok: false, raison: 'La prescription acquisitive vient en dernier : terminez d’abord les recherches REC-01 à REC-07.' };
}

/** Alerte « géomètre nécessaire » (#36, PAR-36) : titre sans référence cadastrale, ou antérieur au seuil versionné. */
export function alerteGeometre(bien: { cadastralRef: string | null; anneeTitre: number | null }, seuilAnnee: number): boolean {
  if ((bien.cadastralRef ?? '').trim() === '') return true;
  return bien.anneeTitre !== null && bien.anneeTitre < seuilAnnee;
}
